import React, { useState, useEffect } from 'react';
import { Button } from '@strapi/design-system/Button';
import { useLibrary } from '@strapi/helper-plugin';
import { useCMEditViewDataManager } from '@strapi/helper-plugin';
import { Typography } from '@strapi/design-system/Typography';
import { Box } from '@strapi/design-system/Box';
import styles from './WidenButton.module.css';
import { ERROR_DISPLAY_NAME, LIBRARY_PLUGIN_NAME, TITLE_LABEL, TYPE_DOCUMENT, TYPE_PDF_OFFICE_ARCHIVE, WINDEN_BUTTON_LABEL } from './contants';
import { Alert } from '@strapi/design-system/Alert';
import { Toggle } from '#shared/components/Toggle/Toggle';
const WidenButton = ({
  name,
  value,
  attribute,
  onChange,
  ...rest
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    components
  } = useLibrary();
  const Component = components[LIBRARY_PLUGIN_NAME];
  const valueObj = value ? JSON.parse(value) : {};
  const [typeMedia, indexMedia] = name.split('.');
  const {
    modifiedData
  } = useCMEditViewDataManager();
  const title = valueObj?.displayName || modifiedData[typeMedia][indexMedia].title || valueObj?.filename;
  const type = modifiedData[typeMedia][indexMedia]?.__component.split('.')[1];
  const filterBytype = type === TYPE_DOCUMENT ? TYPE_PDF_OFFICE_ARCHIVE : type;
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [allowDownload, setAllowDownload] = useState(valueObj.allowDownload || false);
  useEffect(() => {
    if (valueObj?.id && !modifiedData[typeMedia][indexMedia].title) {
      if (!valueObj?.displayName) {
        setIsMessageVisible(true);
      } else {
        setIsMessageVisible(false);
      }
    }
  }, [value]);
  useEffect(() => {
    if (valueObj?.hasOwnProperty('allowDownload') && valueObj.allowDownload !== allowDownload) {
      const dataTemplate = {
        target: {
          name,
          value: JSON.stringify({
            ...valueObj,
            allowDownload
          })
        }
      };
      onChange(dataTemplate);
    }
  }, [allowDownload]);
  const handleMessageClose = () => {
    setIsMessageVisible(false);
  };
  const handleClosed = data => {
    if (data) {
      const dataTemplate = {
        target: {
          name,
          value: JSON.stringify(data[0])
        }
      };
      onChange(dataTemplate);
    }
    setIsVisible(false);
  };
  function createMarkup() {
    return {
      __html: valueObj?.embed_code
    };
  }
  const handleToogleDownload = e => {
    setAllowDownload(state => !state);
  };
  return /*#__PURE__*/React.createElement("div", null, value && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    paddingTop: 2,
    paddingLeft: 4
  }, value && /*#__PURE__*/React.createElement(Typography, {
    variant: "pi",
    fontWeight: "bold"
  }, TITLE_LABEL)), /*#__PURE__*/React.createElement(Box, {
    paddingTop: 2,
    paddingLeft: 4
  }, value && /*#__PURE__*/React.createElement(Typography, {
    variant: "omega",
    fontWeight: "bold"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    paddingTop: 2,
    paddingLeft: 4
  }, isMessageVisible && /*#__PURE__*/React.createElement(Alert, {
    closeLabel: "Close alert",
    title: "No Widen Title",
    onClose: handleMessageClose
  }, ERROR_DISPLAY_NAME)), /*#__PURE__*/React.createElement(Box, {
    paddingTop: 2,
    paddingLeft: 4
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['iframe-container']
  }, value && /*#__PURE__*/React.createElement("div", {
    id: "embedWidenContainer",
    dangerouslySetInnerHTML: createMarkup()
  })))), /*#__PURE__*/React.createElement(Box, {
    paddingTop: 2,
    paddingLeft: 4,
    className: styles.actionContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setIsVisible(true),
    className: styles.button
  }, WINDEN_BUTTON_LABEL), type === 'documents' && valueObj?.id && /*#__PURE__*/React.createElement(Toggle, {
    label: "Enable download",
    name: "allowDownload",
    required: true,
    value: allowDownload,
    onToggleChange: handleToogleDownload,
    onLabel: "on",
    offLabel: "off"
  })), isVisible && /*#__PURE__*/React.createElement(Component, {
    allowedTypes: filterBytype,
    isMultiple: false,
    onClose: handleClosed,
    onSelectAssets: handleClosed
  }));
};
export default WidenButton;